import React from 'react';
import { Loading } from 'components/Btn';
import images from 'assets/img';
import { useSelector } from 'react-redux';

export default function Loader() {
  const { loading } = useSelector(state => state.misc);

  return (
    <>
      {
        loading ? (
          <div className="fixed w-screen h-screen bg-black bg-opacity-30 flex left-0 top-0 z-50">
            <div className="w-20 h-20 m-auto relative">
              <img src={images.Logo_sm} alt="" className="h-8 w-8 left-6 top-6 absolute" />
              <Loading classList="w-20 h-20" />
            </div>
          </div>
        ) : (
          <></>
        )
      }
    </>
  )
}
